/**
 * COMPAT SHIM (2026-07-11) — the old click-to-select controller is retired.
 *
 * Row click now OPENS the row directly (same convention as Cards / Sealed /
 * Rips: click = open, links/buttons inside the row keep their own behavior).
 * The Edit/Print/Delete toolbar is gone — every edit modal already carries
 * those actions in its footer. toolbarHtml() still emits the columns-chooser
 * host so the \u229f Columns control keeps its home, and it still accepts the
 * action array so existing view call-sites compile unchanged.
 */
import { escapeHtml } from "../lib/dom";

export interface RowAction {
  id: string;
  label: string;
  title?: string;
  danger?: boolean;
  handler: (selectedId: string) => void;
}

export class RowSelectionController {
  constructor(private key: string) {}

  /** Retired — selection no longer exists. */
  get selected(): string | null { return null; }
  toggle(_id: string): void { /* retired */ }
  clear(): void { /* retired */ }
  applyUI(): void { /* retired */ }

  /** Inline tr attributes — click opens the row (guarding inner controls). */
  rowAttrs(id: string, onOpenJS?: string): string {
    const safe = escapeHtml(id);
    const open = onOpenJS
      ? ` onclick="if(!(event.target.closest&&event.target.closest('a,button,input,select,label'))){${onOpenJS}}" title="Click to open"`
      : "";
    return `data-${this.key}-row="${safe}" data-selectable${open}`;
  }

  /** Only the columns-chooser host remains; actions are accepted + ignored. */
  toolbarHtml(actions: RowAction[]): string {
    void actions;
    return `<div class="ml-auto"></div><div data-cols-host></div>`;
  }
}

/** Convenient one-liner: create + return. */
export function createRowSelection(key: string): RowSelectionController {
  return new RowSelectionController(key);
}
